import { isEmpty } from 'lodash';
import type { Field } from '../api/Field';
import type { Filter } from '../api/Filter';
import type { FilterEvaluator } from '../api/FilterEvaluator';
import { MatchNoneEvaluator } from '../api/MatchNoneEvaluator';
import type { Value } from '../api/Value';
import { LeafFilterBuilder } from './LeafFilterBuilder';

export class StartsWithFilterBuilder extends LeafFilterBuilder {
  protected _buildEvaluator<RecordType>(
    filter: Filter,
    field: Field<RecordType>,
    values: object[],
  ): FilterEvaluator<RecordType> {
    if (isEmpty(values)) {
      return MatchNoneEvaluator.INSTANCE as FilterEvaluator<RecordType>;
    }
    const comparableValues = this.toComparableValues(field, values);
    return new StartsWithEvaluator(field, comparableValues[0]);
  }
}

export class StartsWithEvaluator<RecordType> implements FilterEvaluator<RecordType> {
  private field: Field<RecordType>;
  private value: Value;

  constructor(field: Field<RecordType>, value: Value) {
    this.field = field;
    this.value = value;
  }

  public evaluate(record: RecordType): boolean {
    const iterable = this.field.getValues(record);
    if (!iterable) {
      return false;
    }
    for (const v of iterable) {
      if (this.evaluateValue(v)) {
        return true;
      }
    }
    return false;
  }

  protected evaluateValue(v: Value): boolean {
    if (v === null || v === undefined || this.value === null || this.value === undefined) {
      return false;
    }
    const s = String(v);
    const prefix = String(this.value);
    if (prefix === '') {
      return false;
    }
    return s.startsWith(prefix);
  }
}
